import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../services/api";
import { Container, Row, Col, Card, CardBody, Table, Button, Alert, Spinner } from "reactstrap";
import "./BusinessLeaveRequests.css";

const BusinessLeaveRequests = () => {
  const { id: businessId } = useParams();
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState({ message: "", type: "" });

  // Fetch leave requests
  useEffect(() => {
    const fetchLeaveRequests = async () => {
      try {
        const response = await api.get(`/business/${businessId}/leave-requests`);
        setLeaveRequests(response.data);
      } catch (error) {
        setAlert({ message: "Failed to fetch leave requests.", type: "danger" });
      } finally {
        setLoading(false);
      }
    };
    fetchLeaveRequests();
  }, [businessId]);

  // Handle Approve/Deny Actions
  const handleAction = async (requestId, status) => {
    try {
      const response = await api.post(`/leave-request/${requestId}/update`, { status });
      if (response.status === 200) {
        setLeaveRequests((prev) =>
          prev.map((req) =>
            req.id === requestId ? { ...req, status, approved_at: new Date().toISOString() } : req
          )
        );
        setAlert({ message: `Leave request ${status.toLowerCase()} successfully.`, type: "success" });
      } else {
        setAlert({ message: "Failed to update leave request.", type: "danger" });
      }
    } catch (error) {
      setAlert({ message: "Error updating leave request.", type: "danger" });
    }
  };

  return (
    <Container className="business-leave-container">
      <Row className="justify-content-center leave-row">
        <Col lg="12" className="mid-layer-leave">
          <Card className="leave-card">
            <CardBody>
              <h4>Leave Requests</h4>

              {/* Success/Error Messages */}
              {alert.message && (
                <Alert color={alert.type} toggle={() => setAlert({ message: "", type: "" })}>
                  {alert.message}
                </Alert>
              )}

              {loading ? (
                <div className="text-center mt-3">
                  <Spinner color="primary" />
                </div>
              ) : leaveRequests.length > 0 ? (
                <Table striped bordered responsive className="leave-table">
                  <thead>
                    <tr>
                      <th>Department</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Leave Type</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Request Type</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {leaveRequests.map((request) => (
                      <tr key={request.id}>
                        <td>{request.department_name}</td>
                        <td>{request.first_name}</td>
                        <td>{request.last_name}</td>
                        <td>{request.leave_type}</td>
                        <td>{new Date(request.start_date).toLocaleDateString()}</td>
                        <td>{new Date(request.end_date).toLocaleDateString()}</td>
                        <td>{request.request_type}</td>
                        <td className={`status-${request.status.toLowerCase()}`}>{request.status}</td>
                        <td className="leave-actions">
                          {request.status === "Pending" ? (
                            <>
                              <Button
                                style={{background: "#28a745"}}
                                size="sm"
                                onClick={() => handleAction(request.id, "Approved")}
                              >
                                Approve
                              </Button>
                              <Button
                                style={{background: "#dc3545"}}
                                size="sm"
                                onClick={() => handleAction(request.id, "Denied")}
                              >
                                Deny
                              </Button>
                            </>
                          ) : (
                            request.status
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <p className="text-muted text-center mt-3">No leave requests available.</p>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default BusinessLeaveRequests;





// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import api from "../services/api";
// import { Container, Row, Col, Card, CardBody, Table, Button, Alert } from "reactstrap";
// import "./BusinessLeaveRequests.css";


// const BusinessLeaveRequests = () => {
//   const {id: businessId } = useParams();
//   const [leaveRequests, setLeaveRequests] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [success, setSuccess] = useState(null);

//   // Fetch leave requests for the business
//   useEffect(() => {
//     const fetchLeaveRequests = async () => {
//       try {
//         const response = await api.get(`/business/${businessId}/leave-requests`);
//         setLeaveRequests(response.data);
//       } catch (error) {
//         setError("Failed to fetch leave requests.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchLeaveRequests();
//   }, [businessId]);

//   // Handle Approve/Deny Actions
//   const handleAction = async (requestId, status) => {
//     try {
//       const response = await api.post(`/leave-request/${requestId}/update`, { status });
//       if (response.status === 200) {
//         setLeaveRequests((prev) =>
//           prev.map((req) =>
//             req.id === requestId ? { ...req, status, approved_at: new Date().toISOString() } : req
//           )
//         );
//         setSuccess(`Leave request ${status.toLowerCase()} successfully.`);
//       } else {
//         setError("Failed to update leave request.");
//       }
//     } catch (error) {
//       setError("Error updating leave request.");
//     }
//   };

//   if (loading) return <p className="text-center mt-5">Loading...</p>;

//   return (
//     <Container className="mt-5">
//       <Row className="justify-content-center">
//         <Col lg="12">
//           <Card className="shadow-lg">
//             <CardBody>
//               <h4 className="text-center mb-4">Leave Requests</h4>

//               {error && <Alert color="danger">{error}</Alert>}
//               {success && <Alert color="success">{success}</Alert>}

//               {leaveRequests.length > 0 ? (
//                 <Table striped bordered responsive className="mt-2">
//                   <thead>
//                     <tr>
//                       <th>Department</th>
//                       <th>First Name</th>
//                       <th>Last Name</th>
//                       <th>Leave Type</th>
//                       <th>Start Date</th>
//                       <th>End Date</th>
//                       <th>Request Type</th>
//                       <th>Status</th>
//                       <th>Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {leaveRequests.map((request) => (
//                       <tr key={request.id}>
//                         <td>{request.department_name}</td>
//                         <td>{request.first_name}</td>
//                         <td>{request.last_name}</td>
//                         <td>{request.leave_type}</td>
//                         <td>{new Date(request.start_date).toLocaleDateString()}</td>
//                         <td>{new Date(request.end_date).toLocaleDateString()}</td>
//                         <td>{request.request_type}</td>
//                         <td>{request.status}</td>
//                         <td>
//                           {request.status === "Pending" ? (
//                             <>
//                               <Button color="success" size="sm" onClick={() => handleAction(request.id, "Approved")}>
//                                 Approve
//                               </Button>{" "}
//                               <Button color="danger" size="sm" onClick={() => handleAction(request.id, "Denied")}>
//                                 Deny
//                               </Button>
//                             </>
//                           ) : (
//                             request.status
//                           )}
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </Table>
//               ) : (
//                 <p className="text-muted text-center mt-3">No leave requests available.</p>
//               )}
//             </CardBody>
//           </Card>
//         </Col>
//       </Row>
//     </Container>
//   );
// };

// export default BusinessLeaveRequests;
